module.exports = __webpack_public_path__ + "assets/img/tobooklink_icon_link.22dcd332.svg";